import { styled } from '@mui/material/styles';

export const StyledIconContainer = styled('div')({
  marginLeft: '17px',
});
